import React from 'react';

import { Space } from '@sravni/react-design-system';
import { Button } from '@sravni/react-design-system/lib/Button';
import { useIsMobile } from '@sravni/react-utils';

import { PRODUCT_LIST_ANCHOR } from '@src/constants/common';
import { scrollToElementById } from '@src/helpers/common';
import { useIsPromoActive } from '@src/reducers/promo';
import { MobileAppConvenienceInfoBox } from 'entities/FullDeal';
import { PromoInfoBox } from 'entities/Promo/ui/PromoInfoBox/PromoInfoBox';
import { ToFullDealAdvertisingButton } from 'features/FullDeal';
import { getFullDealMobileAppLink, getFullDealMobileAppSource } from 'features/FullDeal/config';

interface Props {
  amount: number;
  term: number;
  isLandingPage: boolean;
}

export const FullDealGoogleOfferActions = ({ amount, term, isLandingPage }: Props) => {
  const isMobile = useIsMobile();
  const isPromoActive = useIsPromoActive();

  if (isMobile) {
    const linkWebToApp = getFullDealMobileAppLink(isLandingPage);
    const sourceWebToApp = getFullDealMobileAppSource(isLandingPage);

    const ToAppButton = (
      <ToFullDealAdvertisingButton
        size={52}
        block
        variant="primary"
        link={linkWebToApp}
        color="blue"
        source={sourceWebToApp}
      >
        Получить займ в приложении
      </ToFullDealAdvertisingButton>
    );

    return (
      <Space direction="vertical" size={8}>
        <Space direction="vertical" size={8}>
          {isPromoActive ? (
            <PromoInfoBox isUserFromGoogleSearch link={linkWebToApp} source={sourceWebToApp}>
              {ToAppButton}
            </PromoInfoBox>
          ) : (
            <MobileAppConvenienceInfoBox isUserFromGoogleSearch>{ToAppButton}</MobileAppConvenienceInfoBox>
          )}
        </Space>

        <Button variant="text" size={52} block onClick={() => scrollToElementById(PRODUCT_LIST_ANCHOR)}>
          Продолжить на сайте
        </Button>
      </Space>
    );
  }

  return (
    <Button
      variant="primary"
      color="blue"
      size={60}
      block
      onClick={() => scrollToElementById(PRODUCT_LIST_ANCHOR)}
      style={{ width: 'fit-content' }}
    >
      Подобрать займ
    </Button>
  );
};
